import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getPost, updatePost } from "./postAPI";

const initialState = {
  isLoading: false,
  post: {},
  isError: false,
  error: null,
};

export const fetchPost = createAsyncThunk("post/fetchPost", async (id) => {
  const post = await getPost(id);
  return post;
});

export const modifyPost = createAsyncThunk(
  "posts/modifyPost",
  async ({ id, data }) => {
    const post = await updatePost(id, data);
    return post;
  }
);

export const postSlice = createSlice({
  name: "post",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchPost.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchPost.fulfilled, (state, action) => {
        state.isLoading = false;
        state.post = action.payload;
      })
      .addCase(fetchPost.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(modifyPost.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(modifyPost.fulfilled, (state, action) => {
        state.isLoading = false;
        state.post = action.payload;
      })
      .addCase(modifyPost.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      });
  },
});

export default postSlice.reducer;
